import {afterRender, AfterViewInit, Component, Input, OnInit, Renderer2} from '@angular/core';
import { CommonModule } from '@angular/common';
import {ScriptService} from "../../../services/script.service";
import {window} from "rxjs";

@Component({
  selector: 'instagram-item',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './instagram-item.component.html',
  styleUrl: './instagram-item.component.scss',
  host: {ngSkipHydration: 'true'},
})
export class InstagramItemComponent implements OnInit{
  @Input() code?: string;
  constructor(public scriptService: ScriptService, private renderer: Renderer2) {
    afterRender(()=>{

    })
  }
  ngOnInit(): void {
    this.scriptService.instagramRender();
  }
}

